import { memo } from 'react';
import type { FC } from 'react';

import classes from '../App.module.css';
import resets from '../components/_resets.module.css';
import { Frame1 } from '../components/Frame1/Frame1';

interface Props {
  className?: string;
}
export const Login: FC<Props> = memo(function Login(props = {}) {
  return (
    <div className={`${resets.clapyResets} ${classes.root} ${classes.signin} ${classes.verticallyCentered}`}>
      <Frame1 />
    </div>
  );
});
